import { Stack } from '@fluentui/react';
import React, { useCallback, useMemo } from 'react';
import { useLotsCommerciaux, useLotsCommerciauxManager } from '../../../contexts/lotCommercialContext';
import { useResponsiveSize } from '../../../contexts/responsiveContext';
import DropdownLotCommercial from './NavBarDropdown';
import NavBarItem from './NavBarItem';

const NavBar = () => {

    const { lotsCommerciaux, idOperationActive, idLotCommercialActif } = useLotsCommerciaux();
    const { navBarMaxItems } = useResponsiveSize();
    const { updateLotCommercialActif } = useLotsCommerciauxManager();

    const itemsToDisplay = useMemo(() => {
        if (lotsCommerciaux.lenght <= navBarMaxItems)
            return lotsCommerciaux;
        else return lotsCommerciaux.slice(0, navBarMaxItems);
    }, [lotsCommerciaux, navBarMaxItems]);

    const onClickNavBarItem = useCallback((idOperation, idLotCommercial) => () => {
        updateLotCommercialActif(idOperation, idLotCommercial);
    }, [updateLotCommercialActif]);

    return <Stack as="nav" grow horizontal verticalAlign="end">
        <Stack as="nav" horizontal styles={{ root: { gap: 120 } }}>
            {itemsToDisplay.map((lot, index) => {
                const { idLotCommercial, idOperation, nomCommercial, numero } = lot;
                return <NavBarItem
                    active={idOperation === idOperationActive && idLotCommercial === idLotCommercialActif}
                    key={index}
                    nomCommercial={nomCommercial}
                    numero={numero}
                    onClick={onClickNavBarItem(idOperation, idLotCommercial)}
                />;
            })}
        </Stack>
        <DropdownLotCommercial />
    </Stack>;

};

export default NavBar;